// Service Stores (Add Store — provisioning GTM/GA4).
import { getRequest, postRequest, deleteRequest } from "./api/apiService";

export const STORE_TYPES = ["TikTok", "Snap", "Meta", "Shopify", "LinkedIn", "Other"];

export const fetchStores = () => getRequest("/api/stores");
export const createStore = ({ name, storeType, websiteUrl }) =>
  postRequest("/api/stores", { name, storeType, websiteUrl });
export const fetchStoreStatus = (id) => getRequest(`/api/stores/${id}/status`);
export const fetchStoreSnippet = (id) => getRequest(`/api/stores/${id}/snippet`);
export const deleteStore = (id) => deleteRequest(`/api/stores/${id}`);
